import * as PartnerChatWidget from './components/PartnerChatWidget/PartnerChatWidget';
import * as AuditLogWidget from './components/commonWidgets/AuditLogWidget/AuditLogWidget';
import * as SendGridEmailLogWidget from './components/commonWidgets/SendGridEmailLogWidget/SendGridEmailLogWidget';
import * as order from './components/orderWidgets';
import * as returnAuthorization from './components/returnAuthorizationWidgets';
import * as store from './components/storeWidgets';



export * as AdminQueuingActivityTemplate from './components/AdminQueuingActivityTemplate/AdminQueuingActivityTemplate';
export * as AcceptReturnAuthorizationModal from './components/AcceptReturnAuthorizationModal/AcceptReturnAuthorizationModal';
export * as ApproveReturnAuthorizationModal from './components/ApproveReturnAuthorizationModal/ApproveReturnAuthorizationModal';
export * as BulkReceiveReturnAuthorizationsModal from './components/BulkReceiveReturnAuthorizationsModal/BulkReceiveReturnAuthorizationsModal';
export * as BulkReceiveSpecificReturnAuthorizationsModal from './components/BulkReceiveSpecificReturnAuthorizationsModal/BulkReceiveSpecificReturnAuthorizationsModal';
export * as InitiateReturnModal from './components/InitiateReturnModal/InitiateReturnModal';
export * as SkuSwapModal from './components/SkuSwapModal/SkuSwapModal';
export * as tier1 from './components/tier1';



export const widgets = {
  common: {
    AuditLogWidget,
    SendGridEmailLogWidget,
    PartnerChatWidget
  },

  order,
  returnAuthorization,
  store
};
